export default __webpack_public_path__ + "static/media/press-icon.7083dc3b.svg";